import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    Brevo?: {
      push: (payload: unknown[]) => void;
    };
    __brevoInitialized?: boolean;
  }
}

export function BrevoLoader() {
  const location = useLocation();

  useEffect(() => {
    if (window.__brevoInitialized) return;

    const brevoQueue = window.Brevo || (window.Brevo = []);
    brevoQueue.push([
      'init',
      {
        client_key: 'z5vg733tn2t33wl154twekla',
      },
    ]);

    window.__brevoInitialized = true;
  }, []);

  useEffect(() => {
    const brevoQueue = window.Brevo || (window.Brevo = []);
    brevoQueue.push([
      'page',
      {
        url: `${window.location.origin}${location.pathname}${location.search}`,
        path: location.pathname,
        title: document.title,
      },
    ]);
  }, [location.pathname, location.search]);

  return null;
}
